import React from 'react';

const SignupHeader = ({ step }) => {
  return (
    <div className="mb-8">
      {/* Progress Indicator */}
      <div className="flex items-center justify-between mb-6">
        {/* Step 1 */}
        <div className="flex flex-col items-center flex-1">
          <div
            className="w-10 h-10 rounded-full flex items-center justify-center text-white font-bold transition-all duration-300"
            style={{
              backgroundColor: step >= 1 ? '#0095fa' : '#e5e7eb',
            }}
          >
            1
          </div>
          <p className="text-xs mt-2 text-gray-600" style={{ fontFamily: 'Montserrat' }}>
            Account
          </p>
        </div>

        {/* Line */}
        <div
          className="flex-1 h-1 mx-2 mt-4 rounded-full transition-all duration-300"
          style={{
            backgroundColor: step >= 2 ? '#0095fa' : '#e5e7eb',
          }}
        />

        {/* Step 2 */}
        <div className="flex flex-col items-center flex-1">
          <div
            className="w-10 h-10 rounded-full flex items-center justify-center text-white font-bold transition-all duration-300"
            style={{
              backgroundColor: step >= 2 ? '#0095fa' : '#e5e7eb',
            }}
          >
            2
          </div>
          <p className="text-xs mt-2 text-gray-600" style={{ fontFamily: 'Montserrat' }}>
            Details
          </p>
        </div>
      </div>

      {/* Welcome Text */}
      <h2 className="text-3xl font-bold text-gray-800 mb-2" style={{ fontFamily: 'Montserrat' }}>
        Create Account
      </h2>
      <p className="text-gray-600" style={{ fontFamily: 'Montserrat' }}>
        {step === 1
          ? 'Join our community of caregivers and patients'
          : 'Complete your profile information'}
      </p>
    </div>
  );
};

export default SignupHeader;